import { render } from "./IsoAgency.vue?vue&type=template&id=50f0ad08&scoped=true"
import script from "./IsoAgency.vue?vue&type=script&lang=js"
export * from "./IsoAgency.vue?vue&type=script&lang=js"

import "./IsoAgency.vue?vue&type=style&index=0&id=50f0ad08&scoped=true&lang=css"
import "./IsoAgency.vue?vue&type=style&index=1&id=50f0ad08&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f0ad08"]])

export default __exports__